import type { AgentCursor } from "@/stores/canvas-store";
import type { ActiveExecution, AgentSession } from "@/stores/companion-store";

/** Resolve the durable conversation owned by this runtime segment. */
export function resolveCursorConversationId(
  cursor: AgentCursor,
  executions: Map<string, ActiveExecution>,
  agentSessions: Record<string, AgentSession>,
): string | null {
  const directExecutionId =
    cursor.executionId ??
    (executions.has(cursor.agentId) ? cursor.agentId : undefined);
  const sessions = Object.values(agentSessions);
  const session =
    (cursor.sessionId
      ? sessions.find((item) => item.runtimeSessionId === cursor.sessionId)
      : undefined) ??
    sessions.find((item) => item.runtimeSessionId === cursor.agentId) ??
    (directExecutionId
      ? sessions.find((item) => item.executionId === directExecutionId)
      : undefined);
  return (
    (directExecutionId
      ? executions.get(directExecutionId)?.conversationId
      : null) ??
    session?.conversationId ??
    null
  );
}

export function canOpenCursorConversation(
  cursor: AgentCursor,
  conversationId: string | null,
  currentSpaceId: string | undefined,
  presenting: boolean,
): boolean {
  return !!(
    conversationId &&
    currentSpaceId === cursor.spaceId &&
    cursor.origin !== "heartbeat" &&
    !cursor.question &&
    !presenting &&
    (cursor.frozen || cursor.error) &&
    (cursor.content || cursor.contentFull || cursor.error)
  );
}
